import { BaseModel } from "model/BaseModel";
import HelpdeskTipoChamado from "./HelpdeskTipoChamado";
import Usuario from "model/administracao/cadastro/Usuario";
import Pessoa from "model/administracao/cadastro/Pessoa";
import HelpdeskTramite from "./HelpdeskTramite";
import HelpdeskItemCompra from "./HelpdeskItemCompra";

export default class HelpdeskChamado implements BaseModel {

    id: number;
    codigo: string | null;
    descricao: string;
    status: string;
    dataCriacao: Date;
    tipoChamado: HelpdeskTipoChamado | null;
    prioridade: string;
    usuarioCliente: Usuario | null;
    nomeSolicitante: string | null;
    cliente: Pessoa | null;
    usuarioAtendente: Usuario | null;
    usuarioFinalizado: Usuario | null;
    tramites: HelpdeskTramite[];
    itensCompra: HelpdeskItemCompra[];

    constructor(
        id = 0,
        codigo = null,
        descricao = '',
        status = '',
        dataCriacao = new Date(),
        tipoChamado = null,
        prioridade = '',
        usuarioCliente = null,
        nomeSolicitante = null,
        cliente = null,
        usuarioAtendente = null,
        usuarioFinalizado = null,
        tramites = [],
        itensCompra = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.descricao = descricao;
        this.status = status;
        this.dataCriacao = dataCriacao;
        this.tipoChamado = tipoChamado;
        this.prioridade = prioridade;
        this.usuarioCliente = usuarioCliente;
        this.nomeSolicitante = nomeSolicitante;
        this.cliente = cliente;
        this.usuarioAtendente = usuarioAtendente;
        this.usuarioFinalizado = usuarioFinalizado;
        this.tramites = tramites;
        this.itensCompra = itensCompra;
    }
}